"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _AuthorizationCodeTokenClient = require("./AuthorizationCodeTokenClient");
Object.keys(_AuthorizationCodeTokenClient).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _AuthorizationCodeTokenClient[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _AuthorizationCodeTokenClient[key];
        }
    });
});
var _OidcClient = require("./OidcClient");
Object.keys(_OidcClient).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _OidcClient[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _OidcClient[key];
        }
    });
});
var _OidcUrlHelper = require("./OidcUrlHelper");
Object.keys(_OidcUrlHelper).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _OidcUrlHelper[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _OidcUrlHelper[key];
        }
    });
});
var _TokenClient = require("./TokenClient");
Object.keys(_TokenClient).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _TokenClient[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _TokenClient[key];
        }
    });
});
var _TokenEventNames = require("./TokenEventNames");
Object.keys(_TokenEventNames).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _TokenEventNames[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _TokenEventNames[key];
        }
    });
});
var _TokenRoutes = require("./TokenRoutes");
Object.keys(_TokenRoutes).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _TokenRoutes[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _TokenRoutes[key];
        }
    });
});
var _TokenService = require("./TokenService");
Object.keys(_TokenService).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _TokenService[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _TokenService[key];
        }
    });
});
var _TokenSessionStorageKeys = require("./TokenSessionStorageKeys");
Object.keys(_TokenSessionStorageKeys).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _TokenSessionStorageKeys[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _TokenSessionStorageKeys[key];
        }
    });
});
var _constants = require("./constants");
Object.keys(_constants).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _constants[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _constants[key];
        }
    });
});
var _reactIntegration = require("./react-integration");
Object.keys(_reactIntegration).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _reactIntegration[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _reactIntegration[key];
        }
    });
});
var _storage = require("./storage");
Object.keys(_storage).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _storage[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _storage[key];
        }
    });
});
var _tokens = require("./tokens");
Object.keys(_tokens).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _tokens[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _tokens[key];
        }
    });
});
var _decodeToken = require("./utils/decodeToken");
Object.keys(_decodeToken).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _decodeToken[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _decodeToken[key];
        }
    });
});
var _isTokenValid = require("./utils/isTokenValid");
Object.keys(_isTokenValid).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _isTokenValid[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _isTokenValid[key];
        }
    });
});
var _doDevelopmentLogin = require("./utils/doDevelopmentLogin");
Object.keys(_doDevelopmentLogin).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _doDevelopmentLogin[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _doDevelopmentLogin[key];
        }
    });
});
var _isAuthenticatedCustomer = require("./utils/isAuthenticatedCustomer");
Object.keys(_isAuthenticatedCustomer).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _isAuthenticatedCustomer[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _isAuthenticatedCustomer[key];
        }
    });
}); //# sourceMappingURL=index.js.map
